export const container = `
  text-ll-font-size-p text-ll-on-background font-sans
`;
